var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExcel = function SvgExcel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#107c41",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m7.161 17.417 3.506-5.432-3.211-5.402h2.584l1.752 3.453q.242.491.333.733h.022q.174-.393.363-.764l1.874-3.422h2.372l-3.294 5.372 3.377 5.462h-2.523l-2.025-3.793a3 3 0 0 1-.242-.506h-.03q-.09.259-.234.491L9.7 17.417z"
  })));
};
export default SvgExcel;